export default __webpack_public_path__ + "static/media/resilient_brave.9e3573b5.png";